import api from '../api/axios';

export interface Customer {
  id?: number;
  customerNumber: string;
  companyName?: string;
  contactPerson: string;
  email: string;
  phone?: string;
  mobile?: string;
  address?: string;
  city?: string;
  country?: string;
  taxNumber?: string;
  customerType?: 'individual' | 'business';
  creditLimit?: number;
  paymentTerms?: string;
  notes?: string;
  isActive?: boolean;
  website?: string;
  servicePackage?: number;
  vinNumber?: string;
  plateNumber?: string;
  carMake?: string;
  carModel?: string;
  carYear?: number;
  policyNumber?: string;
  policyStartDate?: string;
  policyEndDate?: string;
}

const CustomerService = {
  getAll: (params?: any) => api.get('/customers', { 
    params: {
      ...params,
      'populate[servicePackage]': '*'
    }
  }),
  getOne: (id: number) => api.get(`/customers/${id}`, {
    params: {
      'populate[servicePackage]': '*'
    }
  }),
  create: (data: Customer) => api.post('/customers', { data }),
  update: (id: number, data: Partial<Customer>) => api.put(`/customers/${id}`, { data }),
  delete: (id: number) => api.delete(`/customers/${id}`),
  checkCustomer: async (customerId?: number, customerNumber?: string) => {
    const response = await api.post('/customers/check-customer', {
      customerId,
      customerNumber
    });
    return response.data;
  }
};

export default CustomerService;

